module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "examples-container"
  }, [(_vm.visible) ? _c('router-link', {
    staticClass: "page-back",
    attrs: {
      "to": '/'
    }
  }, [_c('i', {
    staticClass: "zan-icon zan-icon-arrow"
  })]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea483ea6!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/ExamplesApp.vue
// module id = 198
// module chunks = 2